import { render, staticRenderFns } from "./VolumesList.vue?vue&type=template&id=1e793410&"
import script from "./VolumesList.vue?vue&type=script&lang=js&"
export * from "./VolumesList.vue?vue&type=script&lang=js&"
import style0 from "./VolumesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports